// EP-160 T160-104l (S6): the tenant's ข้อมูลของฉัน page (TH).
// A privacy notice, not a consent: the header names the operator as controller
// and FlowRent as processor. "ความยินยอม" appears only for the withdrawal
// request type, which is about the rewards identity (EP-160 2.7).
export default {
  title: 'ข้อมูลของฉัน',
  home_row_title: 'ข้อมูลของฉัน',
  home_row_subtitle: 'ขอสำเนา ขอลบ หรือขอแก้ไขข้อมูลส่วนบุคคล',
  controller: '{{name}} เป็นผู้ควบคุมข้อมูลส่วนบุคคลของคุณ',
  contact: 'ติดต่อ: {{contact}}',
  processor: '{{processor}} เป็นผู้ประมวลผล',
  policy_link: 'นโยบายความเป็นส่วนตัวของ {{processor}} ›',
  access_button: 'ขอสำเนาข้อมูลของฉัน',
  access_hint: 'ลิงก์ดาวน์โหลดภายใน 30 วัน',
  erasure_button: 'ขอให้ลบข้อมูลของฉัน',
  erasure_hint: 'เจ้าของอาคารเป็นผู้อนุมัติ',
  erasure_confirm_title: 'ขอให้ลบข้อมูลของฉัน',
  erasure_confirm_body:
    'เจ้าของอาคารจะพิจารณาคำขอภายใน 30 วัน เมื่ออนุมัติแล้ว ข้อมูลส่วนบุคคลของคุณจะถูกลบ ส่วนใบแจ้งหนี้และการชำระเงินจะยังเก็บไว้โดยไม่มีชื่อของคุณ',
  erasure_confirm_submit: 'ส่งคำขอ',
  other_button: 'คำขออื่น (แก้ไข / ระงับ / คัดค้าน / ถอนความยินยอม)',
  other_title: 'คำขออื่น',
  other_type_label: 'ประเภทคำขอ',
  other_note_label: 'รายละเอียด',
  other_note_placeholder: 'บอกเจ้าของอาคารว่าต้องการอะไร',
  other_note_required: 'กรุณาระบุรายละเอียด',
  other_note_optional: 'ไม่บังคับ',
  other_submit: 'ส่งคำขอ',
  types: {
    access: 'สำเนาข้อมูล',
    erasure: 'ลบข้อมูล',
    rectification: 'แก้ไขข้อมูล',
    restriction: 'ระงับการใช้ข้อมูล',
    objection: 'คัดค้านการใช้ข้อมูล',
    withdrawal: 'ถอนความยินยอม',
  },
  statuses: {
    pending: 'รอดำเนินการ',
    processing: 'กำลังดำเนินการ',
    completed: 'เสร็จแล้ว',
    rejected: 'ปฏิเสธ',
  },
  requests_title: 'คำขอ',
  requests_empty: 'ยังไม่มีคำขอ',
  sent: 'ส่งคำขอแล้ว เจ้าของอาคารจะตอบภายใน 30 วัน',
  export_ready: 'ลิงก์พร้อมแล้ว ›',
  restriction_lifted: 'ยกเลิกการจำกัดแล้ว เมื่อ {{date}}',
  export_expired: 'ลิงก์หมดอายุ ขอใหม่ได้',
  export_not_ready: 'ลิงก์ยังไม่พร้อม',
  error: 'เกิดข้อผิดพลาด กรุณาลองอีกครั้ง',
}
